module.exports = __webpack_public_path__ + "media/images/map-bkg@2x-918dda9e728ecb750626be83159c45a2.png";